import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import PageLoading from '../helpers/PageLoading';
import { Alert, Box } from '@mui/material';

const ProtectedRoute = ({ children, requireAdmin = false, requireSuperAdmin = false, feature = null }) => {
  const { loading, isAuthenticated, hasAccess, isSuperAdmin, isAdmin } = useUser();

  // Show loading while user data is being fetched
  if (loading) {
    return <PageLoading />;
  }

  // Redirect to home if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Check super admin requirement
  if (requireSuperAdmin && !isSuperAdmin) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Access denied. Super admin privileges required.
        </Alert>
      </Box>
    );
  }

  // Check admin requirement
  if (requireAdmin && !isAdmin) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Access denied. Admin privileges required.
        </Alert>
      </Box>
    );
  }

  // Check feature-specific access
  if (feature && !hasAccess(feature)) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Access denied. You don't have permission to access this feature.
        </Alert>
      </Box>
    );
  }

  return children;
};

export default ProtectedRoute;